<template>
  <div class="wcol-md-4" >
       <div>
     

      <!-- AgGrid Table -->
      <ag-grid-vue
        style="width: 1500px; height: 250px;"
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="contacts"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :rowClassRules="rowClassRules"
        @selectionChanged="saveSelected"
        
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>    
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { repository } from "@/_services/repository.js";
import addNewPrompt from "./addNewPrompt.vue";

// Cell Renderer
import CellRendererLink from "./payListCellRenderer/CellRendererLink.vue";
import CellRendererStatus from "./payListCellRenderer/CellRendererStatus.vue";
import CellRendererActions from "./payListCellRenderer/CellRendererActions.vue";

export default {
  
  components: {
    AgGridVue,
    addNewPrompt,
    CellRendererLink,
    CellRendererStatus,
    CellRendererActions,
  },
  data() {
    return {
      addNewRegister: false,

      searchQuery: "",
      delayedSearchTimer:"",
      contacts: [],
      gridApi: null,
      gridOptions: { rowHeight: 40 },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      rowClassRules: {
        rowColorForNotWorkingPerson: (params) => {
          var personStatus = params.data.status;
          return personStatus == false;
        },
      } /* eslint-disable */,
      columnDefs: [
        {
          headerName: "ID",
          field: "customerId",
          sort: "desc",
          width: 125,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
        {
          headerName: "Adı Soyadı",
          field: "firstName",
          filter: true,
          width: 210,
          cellRendererFramework: "CellRendererLink",
        },
        {
          headerName: "Email",
          field: "email",
          filter: true,
          width: 225,
        },
        {
          headerName: "Etiket",
          field: "userTeam",
          filter: true,
          width: 150,
        },
        {
          headerName: "Bölge",
          field: "detailNote",
          filter: true,
          width: 150,
        },
        {
          headerName: "Telefon",
          field: "phone",
          filter: true,
          width: 150,
        },
        {
          headerName: "Müşteri Temsilcisi",
          field: "addUserID",
          filter: true,
          width: 150,
        },

        {
          headerName: "Abonelik",
          field: "status",
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: "İşlemler",
          field: "transactions",
          width: 150,
          cellRendererFramework: "CellRendererActions",
        },
      ] /* eslint-enable  */,
    };
  },

  computed: {
    
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    //ürünleri çekiyoruz ve çekerken de önceden seçilmiş olanlar (value) ile çekilenleri karşılaştırıp tikleyip en üstte gösteriyoruz,
    
    getProducts: async function () {
      let data = await repository.getAll("Product/getProductsV1").then((r) => r.list);
      this.productDataForAggrid = data;
      this.gridApi.setRowData(this.productDataForAggrid);
      window.watcher = setInterval(this.setSelectedItems, 50, this.gridApi);
    },
    //agden seçilen ürünleri kaydedeceğiz
    saveSelected() {
      let rows = this.gridOptions.api.getSelectedRows();
      this.$emit("saveSelected",rows);
    },
    showAddNew() {
      this.addNewRegister = true;
    },
    hideAddNew() {
      this.addNewRegister = false;
    },

    //fetchusers
   
    getUsers: async function () {
      this.contacts = await repository
        .getAll("Customer/get?currentPage=0&pageSize=100")
        .then((r) => r.list);
    },
    delayedSearch() {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(() => {
        if (this.searchQuery && this.searchQuery.length > 3) this.search();
      }, 500);
    },
   search: async function () {
      this.contacts = await repository
        .getWithParam("Customer/search", "searchQuery=" + this.searchQuery+"&currentPage=0&pageSize=100")
        .then((r) => r.list);
      return this.contacts;
    },
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();
  },
  created() {
    this.getUsers().catch((err) => {
      console.error(err);
    });
  },
};
</script>

<style lang="stylus" scoped>
.rowColorForNotWorkingPerson {
  background-color: rgb(255, 235, 235) !important;
}
</style>